'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

require('./view.less');

var _service = require('./service');

var _next = require('@alifd/next');

var _service2 = require('../common/oss-upload-helper/service');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var SubmitButton = function (_React$Component) {
  _inherits(SubmitButton, _React$Component);

  function SubmitButton(props) {
    _classCallCheck(this, SubmitButton);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.onClick = _this.onClick.bind(_this);
    _this.changeDelay = _this.changeDelay.bind(_this);
    _this.timeChange = _this.timeChange.bind(_this);
    _this.state = {
      delayTime: 0,
      intervalsTime: 60,
      processDisabled: false,
      hasGetCode: false,
      todoTips: '获取验证码',
      processTips: '验证码已发送 ',
      successTips: '重新获取'
    };
    return _this;
  }

  SubmitButton.prototype.componentDidMount = function componentDidMount() {
    var oldTime = sessionStorage.getItem('nowTime_' + location.href),
        nowTime = void 0,
        delayTime = void 0;

    if (oldTime) {
      nowTime = new Date().getTime();
      delayTime = parseInt((nowTime - oldTime) / 1000);
      if (delayTime < this.state.intervalsTime) {
        this.setState({ processDisabled: true });
        this.timeChange(this.state.intervalsTime - delayTime);
      } else {
        this.timeChange(0);
      }
    }
  };

  SubmitButton.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    if (props.disabled) {
      return {
        hasGetCode: false
      };
    }
    return null;
  };

  SubmitButton.prototype.changeDelay = function changeDelay() {
    var nowTime = new Date().getTime();
    window.sessionStorage.setItem('nowTime_' + location.href, nowTime);
    this.setState({ processDisabled: true, hasGetCode: false });
    this.timeChange(this.state.intervalsTime);
  };

  SubmitButton.prototype.timeChange = function timeChange(value) {
    var _this2 = this;

    var delayTime = value;
    if (delayTime > 0) {
      this.setState({ delayTime: delayTime });
      setTimeout(function () {
        _this2.timeChange(delayTime - 1);
      }, 1000);
    } else {
      this.setState({ delayTime: 0, processDisabled: false, hasGetCode: true });
      window.sessionStorage.removeItem('nowTime_' + location.href);
    }
  };

  SubmitButton.prototype.fetchData = function fetchData() {
    var _this3 = this;

    var _props = this.props,
        value = _props.value,
        fieldId = _props.fieldId,
        global = _props.global;

    (0, _service.getCaptcha)({
      phone: value.fieldData.value.phone,
      sequenceNo: (0, _service2.initRequestParams)(fieldId, global).sequenceNo,
      codeLen: value.codeLen,
      fieldName: value.fieldId
    }).then(function () {
      var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      _this3.changeDelay();
      _this3.props.emitSendSuccess({ cid: res.cid, checksum: res.checksum });
    });
  };

  SubmitButton.prototype.onClick = function onClick() {
    this.fetchData();
    this.props.emitClick();
  };

  SubmitButton.prototype.render = function render() {
    return _react2.default.createElement(
      _next.Button,
      {
        type: 'secondary',
        disabled: this.props.disabled || this.state.processDisabled,
        onClick: this.onClick,
        size: 'small',
        style: { margin: 4 }
      },
      this.state.hasGetCode ? this.state.successTips : this.state.processDisabled ? this.state.processTips + ' ' + this.state.delayTime + 's' : this.state.todoTips
    );
  };

  return SubmitButton;
}(_react2.default.Component);

exports.default = SubmitButton;
module.exports = exports['default'];